import get from 'lodash.get'

import { isClient } from '@cred/shared/utils'

import { YOUNG_ALFRED_STORAGE_KEY, INSURANCE_FORM_INITIAL_VALUES_FIELDS } from 'common/constants'

import getPolicyType from './getPolicyType'
import pick from './pick'

export const getInsurancePrefillData = () => {
  const savedYAData = JSON.parse(window.localStorage.getItem(YOUNG_ALFRED_STORAGE_KEY))
  const prefill = get(savedYAData, 'application.start', {}) || {}

  const obj = Object.keys(prefill).reduce(
    (acc, curr) => ({
      ...acc,
      ...(!!prefill[curr] && { [curr]: prefill[curr] }),
    }),
    {},
  )

  return obj
}

export const createInsurancePrefillData = ({ search }) => {
  const bowtieWidgetsInitialValues = pick(search, INSURANCE_FORM_INITIAL_VALUES_FIELDS)
  const { policyType } = search
  const prefill = getInsurancePrefillData()

  return {
    application: {
      start: {
        ...bowtieWidgetsInitialValues,
        policyType: getPolicyType(policyType),
        ...prefill, // don't override existing data
      },
    },
  }
}

export const setInsuranceFormInitialValues = ({ search }) => {
  if (!isClient()) return

  window.localStorage.setItem(
    YOUNG_ALFRED_STORAGE_KEY,
    JSON.stringify(createInsurancePrefillData({ search })),
  )
}
